import { Constants } from "utility/enums/constants";

const TermsAndConditions: React.FC = () => {
  return (
    <iframe
      style={{ width: "100%", height: "100vh" }}
      src={
        Constants.TermsAndConditionPDFPath.toString() +
        "?v=" +
        new Date().getTime()
      }
    ></iframe>
  );
};

export default TermsAndConditions;
